import { getInsuranceType } from '../../utils'
export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	let arr = [
		{
			label: '派单公司',
			value: order.company,
		},
		{
			label: '所属险种',
			value: getInsuranceType(setting, order),
		},
		{
			label: '报案号',
			value: order.caseNo,
		},
		{
			label: '服务公司',
			value: order.serviceCompanyName,
		},
		{
			label: '订单号',
			value: order.orderNo,
		},
		{
			label: '任务类型',
			value:
				!`${setting.subTasktypeMap[order.subTaskType]}` ||
				`${setting.subTasktypeMap[order.subTaskType]}` == undefined ||
				`${setting.subTasktypeMap[order.subTaskType]}` == 'undefined'
					? `${setting.surveryTasktypeMap[order.taskType]}`
					: `${setting.surveryTasktypeMap[order.taskType]}-${
							setting.subTasktypeMap[order.subTaskType]
					  }`,
		},
		// {
		// 	label: '订单类型',
		// 	value: setting.orderTypeMap[order.orderType],
		// },
		{
			label: '调查地区',
			value: order.clinicArea,
		},
		{
			label: '调查详细地址',
			value: order.address,
		},
		{
			label: '联系人姓名',
			value: order.linkman,
		},
		{
			label: '联系人电话',
			value: order.linkmanPhone,
		},
		{
			label: '案件负责人姓名',
			value: order.contact,
		},
		{
			label: '案件负责人电话',
			value: order.contactPhone,
		},
	]

	let pointStr = ''
	let pointList = injured.pointList || []

	pointList.forEach((item, index) => {
		pointStr += `${index + 1}. ${item.checkPoint} `
	})

	arr.push(
		{
			label: '核查重点',
			value: pointStr,
		},
		{
			label: '任务要求',
			value: order.visitRequest,
		},
		{
			label: '任务单证',
			value: order.mediaList || [],
			slot: 'mediaList',
		}
	)
	if (order.cancelReason) {
		arr.push({
			label: '撤单原因',
			value: order.cancelReason,
		})
	}
	return {
		title: '任务信息',
		children: arr,
		span: {
			核查重点: 24,
			任务要求: 24,
			任务单证: 24,
		},
	}
}
